import React from "react";
import MetaTags from "../../components/generic/MetaTags";
import ExampleUI from "../../components/sop/ExampleUI";
import Navbar from "../../components/Landing/LandingNavbar";
import Head from "next/head";

const data = {
  "@context": "http://schema.org",
  "@type": "WebPage",
  name: "Tootler.ai - SOP Templates",
  description:
    "Tootler.ai is a free SOP generator that helps you create professional and polished SOPs in minutes. It's easy to use, and it comes with a variety of features that will make the SOP writing process a breeze. You can also use our plagiarism checker to ensure that your SOPs are original and free of plagiarism. This is important because plagiarism can lead to rejection from schools and employers. Our SOP generator is the perfect tool for anyone who needs to write an SOP. It's easy to use, and it comes with a variety of features that will make the SOP writing process a breeze. Templates provide a starting point for your own SOPs. They are designed to be easy to use and customize, so you can create the perfect SOP for your needs. You can also use our plagiarism checker to ensure that your SOPs are original and free of plagiarism. This is important because plagiarism can lead to rejection from schools and employers. ",

  url: "https://tootler.ai/sop-templates",

  mainEntityOfPage: {
    "@type": "WebPage",
    "@id": "https://tootler.ai/sop-templates",
  },
  breadcrumb: {
    "@type": "BreadcrumbList",
    itemListElement: [
      {
        "@type": "ListItem",
        position: 1,
        name: "Tootle.ai",
        item: "https://tootler.ai/",
      },
      {
        "@type": "ListItem",
        position: 2,
        name: "SOP Templates",
        item: "https://tootler.ai/sop-templates",
      },
    ],
  },
};

const examplesPage = () => {
  return (
    <>
      <Head>
        <script
          key="structured-data"
          type="application/ld+json"
          dangerouslySetInnerHTML={{ __html: JSON.stringify(data) }}
        />
        <meta
          name="title"
          content="Top-Quality SOP Templates for Your Application | Tootle AI"
        />
        <meta
          name="description"
          content="Browse our collection of top-quality SOP templates to create the perfect statement of purpose and ensuring your application stands out from the competition."
        />
      </Head>
      <main className="font-Inter">
        <MetaTags PageName="SOP Examples" />
        <Navbar />
        <ExampleUI />
      </main>
    </>
  );
};

export default examplesPage;
